import React from "react";
import { Button, Result, PageHeader } from 'antd';

export function Unsubscribe() {
    return (
        <div className={'unsubscribe'}>
            <PageHeader
                className="site-page-header"
                title="Group"
                avatar={{ src: 'https://eupgroup.net/images/logo.png' }}
            />
            <Result
                status="success"
                title="Unsubscribe successfully!"
                subTitle="Thank you. Your request has been submitted."
                extra={[
                    <a href={'https://eupgroup.net/'} type="primary" key="console">
                        Go to home page
                    </a>
                ]}
            />
        </div>
    )
}